
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Est-ce que ça coûte quelque chose ?',
      answer: 'Non, 100% gratuit ! VirtualEat ne vous demande aucun investissement initial. Nous sommes rémunérés uniquement sur les ventes supplémentaires générées, donc si vous ne vendez pas plus, vous ne payez rien.'
    },
    {
      question: 'Dois-je changer mon menu ou ma cuisine ?',
      answer: 'Absolument pas ! Nous nous appuyons sur vos plats existants. Nous créons simplement de nouvelles marques virtuelles avec vos recettes actuelles, optimisées pour différents segments de clients.'
    },
    {
      question: 'Et si ça ne marche pas ?',
      answer: 'Aucun engagement, aucun risque ! Si les résultats ne sont pas au rendez-vous, vous pouvez arrêter à tout moment sans frais. Nous sommes tellement confiants que nous garantissons une augmentation de vos ventes.'
    },
    {
      question: 'Combien de temps faut-il pour voir les résultats ?',
      answer: 'En moyenne, nos clients voient leurs premières commandes supplémentaires dans les 15 premiers jours. Les résultats significatifs (+20% de CA) apparaissent généralement au bout de 4 à 6 semaines.'
    },
    {
      question: 'Comment gérez-vous les commandes supplémentaires ?',
      answer: 'C\'est simple ! Les commandes arrivent sur vos plateformes habituelles (Uber Eats, Deliveroo, etc.) avec les noms de vos nouvelles marques virtuelles. Vous préparez exactement les mêmes plats qu\'avant, juste avec plus de volume.'
    },
    {
      question: 'Sur quelles plateformes travaillez-vous ?',
      answer: 'Nous travaillons avec toutes les principales plateformes : Uber Eats, Deliveroo, Just Eat, et d\'autres selon votre zone géographique. Nous choisissons les meilleures pour maximiser votre visibilité.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Toutes les réponses à vos questions sur VirtualEat
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm mb-4 overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-[#9EFD38] text-xl transition-transform duration-300`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-gray-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-4">
            Vous avez d'autres questions ?
          </p>
          <a 
            href="mailto:gabrielmarandyukpro@gmail.com"
            className="text-[#9EFD38] font-semibold hover:underline"
          >
            Contactez-nous directement
          </a>
        </div>
      </div>
    </section>
  );
}
